export enum ButtonTypes {
    link = 'link',
    primary = 'primary',
    secondary = 'secondary'
}